// extracted by mini-css-extract-plugin
module.exports = {"page":"page__OY9ue","err-con":"err-con__3QQde"};